// Coquille de l'app connectée, aux couleurs du club (D-024) : barre du haut
// (logo, nom du club, mes casquettes ; la casquette Bénévole porte la pastille des créneaux
// qui manquent dans les 7 jours, D-097), onglets du bas selon mes casquettes, routes.
//   #/                     accueil (ce qui me concerne, par casquette)
//   #/planning             les 3 prochaines semaines
//   #/t/<id>               équipe
//   #/plays[/<équipe>]     les plays de l'équipe (onglet Basket)
//   #/matchs[/<équipe>|/resultats]  un seul écran Matchs (D-132) : tout le club, filtre par équipe ; une équipe : résultats,
//                          FFBB (#/matchs-club y mène, sauf pour l'abonné)
//   #/indispos             mes indisponibilités (ou celles de mes enfants)
//   #/club[/<section>]     le club : vie du club pour tous ; pour le bureau, une rubrique par objectif, ses modules éteints et
//                          ses réglages (D-132)
// D-139 (src/ui/nav.ts, src/domain/nav.ts) : un module = une page, ses vues en segments qui remplacent l'adresse ; la ⚙ (à
//   gauche du « ? ») ouvre UNE page de réglages en rubriques repliables, #/<module>/reglages[/<rubrique>] ; « ‹ X » dit d'où
//   l'on vient et y ramène (sans historique : le parent du module), l'onglet d'origine reste allumé. Les adresses d'avant
//   (#/club/benevolat…, #/salles/gestionnaires, #/avantages/gestion, #/lien/offres, #/subventions/pieces…) y mènent.
//   #/benevoles/reglages[/…] les réglages du bénévolat (D-127, bureau, module Bénévolat) : besoins des matchs, parcours, ranger
//                          les créneaux, récompenses, jeunes, groupes, annonces et relances (src/ui/reglages.ts)
//   #/e/<id>/<date>        fiche d'une séance
//   #/repartir/<id>/<id>   deux matchs du groupe le même jour : répartir les joueuses (staff, D-092)
//   #/notifs               notifications (cloche)
//   #/annonces[/<id>]      annonces du club et de mes équipes
//   #/benevoles            créneaux de bénévoles à prendre ; /badges : badges du bureau (D-100) ; /matchs et /parcours
//                          mènent aux réglages du bénévolat (D-127, D-139) ;
//                          /groupes, /groupe/<id>[/membres|/fil], /challenge : les groupes de bénévoles (D-105)
//   #/badges[/<parcours>]  mes badges, un parcours (D-100)
//   #/licences             dossiers de licence de la saison (bureau) ; /reglages : Réglages · Licences, une page à part (D-139)
//   #/licences/import      import des licenciés (FBI, tableur), D-079
//   #/essais               essais et demandes : page publique, liens d'équipe, amies (bureau, coachs)
//   #/membres              membres et rôles (bureau, D-075)
//   #/inviter[/equipe/<id>] inviter : une amie, un bénévole ; le coach, son équipe (D-075)
//   #/partenaires[/<id>]   partenaires : gestion (bureau), offres (membres) ; la fiche d'un partenaire (bureau, D-125) ;
//                          /reglages : les réglages des partenaires, sortis de la page du quotidien (D-127, D-132, D-139)
//   #/lien                 garder le lien avec les partenaires (bureau, D-125 ; un segment de Partenaires, D-139) ;
//                          côté partenaire : « Le club vous invite »
//   #/pistes               trouver un partenaire : les entreprises que j'ai apportées (D-096)
//   #/subventions[/…]      dossiers de subvention (bureau, D-112) : calendrier, dossiers, fiche action, CERFA ; /reglages :
//                          les pièces et les chiffres (D-139)
//   #/prospection[/…]      prospection de partenaires : entreprises, suivi, fiche, kit (bureau, D-111)
//   #/salles[/…]           le planning des salles (module, D-123) : les salles, le planning d'une salle, les demandes
//   #/agenda               agenda du club : tournois, lotos, AG… (inscriptions ; gestion au bureau)
//   #/moi                  moi : prénom, indispos, dossier, notifications
//   #/suivis               mes suivis (D-110) : les groupes et équipes que je suis, leurs réglages ; l'abonné (compte de la
//                          page publique) n'a que #/ (les matchs du club), #/suivis, #/moi, #/notifs, #/aide
//   #/enfants              mes enfants : équipe, prochain rendez-vous, dossier, code perso
//   #/console[/…]          console de l'éditeur : clubs, inscriptions, nouveau club, fiche (D-081), prospection (D-086)
//   #/club/modules[/choisir|/proposer] les modules du club (D-122, D-132) : Club › Modules par objectif ; « Qu'est-ce qui prend
//                          le plus de temps au bureau ? » et « Pour le club : N modules » (premiers pas)
//   #/ressentis[/<équipe>[/semaine|/saison|/o/<séance>/<date>]|/reglages] les ressentis (D-143) : le bureau, des moyennes par
//                          équipe ; le staff, les réponses de son équipe ; la ⚙ (après quelles séances)
//   #/bilan[/<personne>|/continuer|/suivi[/personnes|/mots]|/reglages|/equipe] le bilan de saison (D-143) : le licencié, son
//                          parent ; la prévision du bureau ; la ⚙ (les dates)
//   #/nouvelle-saison[/1..4] l'assistant « Nouvelle saison » (D-143, D-115), au bureau
//   #/defis[/<équipe>[/gages]] défis et gages (D-047 ; #/groupe… y mène, D-132 : « groupe » est aux groupes de bénévoles)
//   Une page d'un module éteint (D-122) : « Ce module n'est pas utilisé par le club » (Activer, Demander au bureau).
//   #/mains-vives[/…]      « Mains vives », le premier jeu caméra (D-164, bêta) : la séance (/pour/<enfant> : un parent), /progression,
//                          /enfant/<enfant> (le parent d'un mineur), /equipe/<équipe> (le coach propose) ; src/ui/mains-vives.ts
//   #/formation[/…]        la formation des officiels (D-141, bêta club pilote) : Mes parcours · À valider (référent) · Nos officiels
//                          (bureau) ; /otm, /arb, /arb2 un parcours ; /reglages la ⚙ (src/ui/formation.ts)
//   #/aide[/<tuto>]        aide : les tutos de mes casquettes ; /ecrire, /messages : le support (D-082) ;
//                          /premiers-pas : mes premiers pas, tous mes rôles (D-091)
//   #/support[/<id>]       boîte du support (admins de la plateforme seulement, D-081)
//   #/rt/…                 l'espace du responsable technique (D-093, rt-routes.ts)
//   #/evaluation/<c>/<équipe>  saisie rapide d'une évaluation ; #/composition/<id> : brouillon de composition (D-093)
import { appHeadChanged, ensureAppIcon, reloadForAppHead } from './app-icon';
import { ensureOgImage } from './og-image';
import { signOut } from '../lib/auth';
import { betaOpen, mvOpen, children, firstName, hatAmong, loadContext, mainHat, me, genderOf, modOn, personaOf, refreshHats, STAFF_HATS, switchHat, takeHatChosen, volunteerApart, workTeams, type Ctx, type HatKey } from './context';
import { bureauTabs, moduleOfRoute, renamedRoute } from '../domain/modules';
import { hasPublishedPlay } from '../lib/modules-api';
import { renderModuleOff, renderPartnerPaused } from './modules';
import { renderHome } from './home';
import { renderPlanning } from './planning';
import { renderFeuilles } from './feuilles';
import { renderDerogations } from './derogations';
import { renderEvent } from './event';
import { renderMatchDay } from './match-day';
import { renderUnavailability } from './unavailability';
import { renderTeam } from './team';
import { renderTeamSettings } from './desist';
import { renderClubHub } from './club-hub';
import { renderNotifs } from './notifs';
import { renderAnnouncements, showAnnouncementPrompts } from './announcements';
import { renderVolunteerBoard, renderVolunteerPage, weekPlaces } from './volunteer';
import { renderBadges, showGradeUps } from './badges';
import { decorateBadges, renderFormation } from './formation';
import { renderMainsVives } from './mains-vives';
import { renderVolunteerSettings } from './reglages';
import { movedRoute } from '../domain/reglages';
import { movedNavRoute } from '../domain/nav';
import { beginNav, finishNav } from './nav';
import { renderVolunteerGroup, renderVolunteerGroups, renderVolunteerRecruits } from './volunteer-groups';
import { renderGroupChallenge, renderGroupFeed, renderGroupMembers } from './groupes';
import { renderMatchs } from './matchs';
import { renderFollowerHome, renderMyFollows } from './suivre';
import { renderMentorPage, renderMentoringAdmin } from './mentoring';
import { renderPrepa } from './prepa';
import { renderBasket, type BasketSeg } from './basket';
import { renderPlayPage } from './play-page';
import { renderSeance } from './seance';
import { renderPerks, renderPerksAdmin } from './perks';
import { renderLiveStats } from './live-stats';
import { offlineResume } from './table';
import { renderGroupLife } from './group-life';
import { renderLicences, renderLicenceSettings } from './licences';
import { renderImport } from './import-licences';
import { renderTrials } from './trials';
import { renderMembers } from './members';
import { renderInviteMe } from './invite-me';
import { renderTeamInvites } from './invite-team';
import { renderPartners, renderPartnerSettings } from './partners';
import { renderLien, renderPartnerLien } from './lien';
import { renderMyLeads } from './apporteurs';
import { renderSubventions } from './subventions';
import { renderFeelings } from './ressentis';
import { renderBilan } from './bilan';
import { renderNewSeason } from './nouvelle-saison';
import { renderReceiptsWithKm } from './recus-entries';
import { renderProspection } from './partner-prospect';
import { renderSallesRoute, sallesOn } from './salles-module';
import { renderClubAgenda } from './club-events';
import { renderMe, renderKids } from './me';
import { renderConsole } from './console';
import { renderHelp } from './help';
import { renderSupportInbox } from './support-inbox';
import { renderPartnerClub, renderPartnerHome, renderPartnerPublish, renderPartnerVisibility } from './partner-app';
import { syncPush, unreadCount } from '../lib/notifications';
import { installFfbbHealth, scheduleFfbbReads } from '../lib/ffbb-sync';
import { isRtView } from './rt-shared';
import { renderRt, rtIsTabPage, rtTab } from './rt-routes';
import { renderRtHome } from './rt-home';
import { renderCoachComposition, renderCoachEvaluation } from './rt-coach';
import { agree } from '../domain/labels';
import { supabase } from '../lib/supabase';
import { applyBrand, clubMark } from './theme';
import { $, html, mount } from './dom';
import { guideAfterRender } from '../guide';
import { openTerrain } from './drills';
import { saveSkin, showSkin, shownSkin } from './skin-boot';
import { skinHatOn, skinsFor } from './skin-owner';

let ctx: Ctx | null = null;
let appRoot: HTMLElement | null = null;
/** Côté joueuses (D-122) : « Plays » n'apparaît qu'au premier play publié de leurs équipes ; relu une fois par visite. */
let playsSeen: { key: string; yes: boolean } | null = null;
async function playsTab(c: Ctx): Promise<boolean> {
  const ids = c.teams.map(t => t.id).sort();
  const key = ids.join(',');
  if (playsSeen?.key === key) return playsSeen.yes;
  const yes = await hasPublishedPlay(ids).catch(() => true);
  playsSeen = { key, yes };
  return yes;
}
/** La casquette du dernier écran affiché : une page d'un autre rôle qui la change est annoncée (D-101). */
let shownHat: HatKey | null = null;

export function resetApp(): void { ctx = null; shownHat = null; playsSeen = null; }

/** Passer à une casquette : l'accueil de ce rôle, ses onglets (barre des casquettes, ligne « Bénévole › »). */
function goHat(root: HTMLElement, c: Ctx, key: HatKey): void {
  if (key === c.hat || !c.hats.some(h => h.key === key)) return;
  switchHat(c, key, true);
  if (location.hash === '#/' || location.hash === '') void renderApp(root); else location.hash = '#/';
}

/** Une page de la casquette Bénévole ouverte depuis une autre (lien d'une annonce de relance, tuile du club,
 *  notification) : on passe dans la casquette Bénévole, comme une séance passe dans la bonne casquette (D-072).
 *  Le bureau garde son bénévolat (il organise) ; l'espace partenaire passe aussi pour la vie du club (D-071). */
const PARTNER_OUT = new Set(['benevoles', 'avantages', 'inviter', 'matchs', 'agenda', 'annonces', 'badges']);
function volunteerRoute(c: Ctx, page: string | undefined, sub?: string): boolean {
  if (!page || !volunteerApart(c)) return false;
  if (page === 'benevoles' && sub === 'reglages') return false;   // les réglages du bénévolat (D-139) : au bureau
  return c.hat === 'partenaire' ? PARTNER_OUT.has(page) : page === 'benevoles' && c.hat !== 'bureau' && c.hat !== 'console';
}

/** Les pages de la casquette Bénévole et celles de tout le monde (Moi › Mes suivis compris : D-121, lot 0). Les autres
 *  (planning, enfants, indisponibilités, équipe, séance, gestion du bureau…) ouvertes depuis la casquette Bénévole
 *  passent dans la casquette principale. */
const VOLUNTEER_PAGES = new Set(['', 'a-faire', 'matchs', 'benevoles', 'club', 'moi', 'suivis', 'notifs', 'annonces', 'agenda', 'avantages', 'inviter', 'pistes', 'partenaires', 'aide', 'support', 'badges', 'formation']);
/** Les sous-pages de tout le monde, aussi dans la casquette Bénévole : « Qui contacter » et « Messages au bureau » (tuiles du
 *  Club de la casquette Bénévole, D-126), « Demander le club-house » (D-123). Le reste de #/club/… est au rôle. */
const VOLUNTEER_SUBS = new Set(['club/contacter', 'club/messages', 'salles/demander']);
function roleRoute(c: Ctx, [page = '', sub]: string[]): boolean {
  if (c.hat !== 'benevole') return false;
  if (sub && VOLUNTEER_SUBS.has(`${page}/${sub}`)) return false;
  if (!VOLUNTEER_PAGES.has(page)) return true;
  // « Inviter les Seniors filles » (#/inviter/equipe/…) : un outil du coach, dans sa casquette (D-097).
  return (page === 'club' && !!sub && !/^[0-9a-f-]{36}$/i.test(sub)) || (page === 'avantages' && sub === 'gestion') || (page === 'partenaires' && !!sub)
    || (page === 'inviter' && sub === 'equipe') || (page === 'benevoles' && sub === 'reglages')
    || (page === 'formation' && (sub === 'officiels' || sub === 'reglages') && c.full.adminOf.length > 0);   // D-141 : le bureau
}

/** Les pages du staff (les demandes d'essai) ouvertes depuis la casquette Joueuse, Parent ou Bénévole (la notification
 *  « Demande · Lina ») : la casquette qui les montre, le coach d'abord, comme une séance (D-072). */
const STAFF_PAGES = new Set(['essais']);
const staffRoute = (c: Ctx, page: string | undefined): HatKey | null => (page && STAFF_PAGES.has(page) ? hatAmong(c, STAFF_HATS) : null);

/** Ligne des casquettes, sous le nom du club : « COACH · SENIORS FILLES 1 · ADMIN ». */
/** La console de l'éditeur est affichée (casquette choisie, ou seule casquette). */
export const inConsole = (c: Ctx) => c.hat === 'console' || (c.platformAdmin && c.hats.length === 1);

function roleLine(c: Ctx): string {
  if (inConsole(c)) return 'Console · éditeur';
  if (c.hat === 'partenaire') return `Partenaire · ${c.partners[0]?.name ?? ''}`;
  // Plusieurs casquettes (D-072) : celle affichée ; les autres sont dans les onglets du haut.
  if (c.hats.length > 1) return c.hats.find(h => h.key === c.hat)?.label ?? '';
  const roles: string[] = [];
  if (personaOf(c) === 'partenaire') return `Partenaire · ${c.partners[0]?.name ?? ''}`;
  if (personaOf(c) === 'abonne') return 'Abonné';
  const staff = c.teams.filter(t => c.coachOf.has(t.id));
  if (c.roles.some(r => r.role === 'technical' && r.club_id === c.club?.id)) roles.push('Resp. technique');
  else if (staff.length) roles.push(`Coach · ${staff[0]!.name}${staff.length > 1 ? ` +${staff.length - 1}` : ''}`);
  const self = me(c);
  const myTeam = self ? c.teams.find(t => c.memberships.some(m => m.person_id === self.id && m.team_id === t.id)) : null;
  if (self && myTeam) roles.push(`${agree(genderOf(c, self.id), 'Joueur', 'Joueuse')} · ${myTeam.name}`);
  if (children(c).length) roles.push('Parent');
  // Supporter seul (D-064) : sa seule casquette est Bénévole (D-097).
  if (!roles.length && c.roles.some(r => r.role === 'supporter')) roles.push('Bénévole');
  if (c.adminOf.length) roles.unshift('Bureau');
  return roles.slice(0, 2).join(' · ');
}

export async function renderApp(root: HTMLElement): Promise<void> {
  if (!ctx) {
    mount(root, html`<div class="loading" aria-busy="true"><div class="ball spin" aria-hidden="true"></div></div>`);
    try { ctx = await loadContext(); }
    catch { mount(root, html`<div class="empty"><p class="empty-title">Connexion au serveur impossible.</p><button class="btn btn-primary" id="b-retry">Réessayer</button></div>`);
      $(root, '#b-retry')?.addEventListener('click', () => renderApp(root));
      // La table de marque de ce téléphone se rouvre hors réseau (D-176) : son journal part au retour du réseau.
      const tb = /^#\/stats\/([0-9a-f-]{36})/.exec(location.hash)?.[1];
      if (tb) offlineResume(root, { event: tb });
      return; }
    if (!ctx) return;
    applyBrand(ctx.club);
    // La page a démarré sans ce club (première connexion sur app.arceau.app) : un rechargement, pour que
    // Safari pose l'app du club sur l'écran d'accueil, avec son icône et son nom (D-104).
    if (appHeadChanged() && reloadForAppHead()) return;
    void ensureAppIcon(ctx.club, !!ctx.club && ctx.adminOf.some(k => k.id === ctx!.club!.id));   // D-102
    void ensureOgImage(ctx.club, !!ctx.club && ctx.adminOf.some(k => k.id === ctx!.club!.id));   // aperçu des liens partagés
    void syncPush();   // appareil déjà abonné : il passe au compte connecté
    // Les annonces à afficher en grand (D-062) : à chaque ouverture de l'app.
    void showAnnouncementPrompts().catch(() => undefined);
    // Un nouveau grade (D-100) : la fête, une fois, à l'ouverture (avec le bénévolat, D-122).
    if (modOn(ctx, 'benevolat')) void showGradeUps(ctx).catch(() => undefined);
    // Les skins (D-149, D-154, D-157) : le skin porté et la victoire à fêter, rien d'autre (pas d'annonce) ; module éteint, ou
    // pas de skins dans ce club (un coach) : les couleurs du club.
    if (skinsFor(ctx)) { const c0 = ctx; void import('./skins').then(m => m.startSkins(c0)).catch(() => undefined); }
    else saveSkin(null);
    // D-113 : les lectures FFBB que la base réclame, en arrière-plan, après l'affichage ; les échecs sont signalés.
    installFfbbHealth();
    const full = ctx.full;
    scheduleFfbbReads(full.teams.filter(t => full.staffOf.has(t.id)).map(t => ({ id: t.id, club_id: t.club_id })));
  }
  const c = ctx;
  appRoot = root;
  // Une page déplacée (D-127 : l'onglet « Matchs » et « Parcours et récompenses » sont dans Club › Bénévolat) : sa
  // nouvelle adresse, sans entrée de plus dans l'historique.
  // D-132 : les défis passent sous #/defis, les matchs du club sous #/matchs (un seul écran).
  // D-139 : les réglages en une page par module (Club › Bénévolat, Gestionnaires, Gérer les avantages, Ce que le club offre…).
  const moved = movedNavRoute(location.hash) ?? movedRoute(location.hash) ?? renamedRoute(location.hash, personaOf(c) === 'abonne');
  if (moved) history.replaceState(history.state, '', moved);
  // D-139 : le bureau a une seule vue des groupes de bénévoles, le segment Groupes de son onglet Bénévolat.
  else if (c.hat === 'bureau' && /^#\/benevoles\/groupes\/?$/.test(location.hash)) history.replaceState(history.state, '', '#/benevoles/equipe');
  // D-139 : d'où vient-on (le nom de la page d'avant, son onglet) ; une nouvelle entrée d'historique le retient.
  const from = beginNav(document.getElementById('view'));
  const asked = location.hash.replace(/^#\/?/, '').split('/');
  const staffHat = staffRoute(c, asked[0]);
  // D-143 : mon bilan (et « Tu continues ? ») se remplit dans la casquette Joueuse ou Parent ; les ressentis d'une équipe et
  // ses projets se lisent dans la casquette du coach.
  // D-164 : Mains vives se joue dans la casquette Joueuse ou Joueur ; le parent lance la séance de son enfant ; le coach propose.
  const mvHat = asked[0] !== 'mains-vives' ? null : asked[1] === 'equipe' ? hatAmong(c, STAFF_HATS)
    : asked[1] === 'enfant' || asked[1] === 'pour' || (asked[1] === 'progression' && !!asked[2]) ? hatAmong(c, ['parent']) : hatAmong(c, ['joueur']);
  const bilanHat = asked[0] === 'bilan' && (!asked[1] || asked[1] === 'continuer' || /^[0-9a-f-]{36}$/i.test(asked[1])) ? hatAmong(c, ['joueur', 'parent'])
    : (asked[0] === 'ressentis' && /^[0-9a-f-]{36}$/i.test(asked[1] ?? '')) || (asked[0] === 'bilan' && asked[1] === 'equipe') ? hatAmong(c, ['coach']) : null;
  if (volunteerRoute(c, asked[0], asked[1])) switchHat(c, 'benevole');
  else if (staffHat) switchHat(c, staffHat);
  else if (bilanHat) switchHat(c, bilanHat);
  else if (mvHat) switchHat(c, mvHat);
  else if (roleRoute(c, asked)) switchHat(c, mainHat(c)!);
  // Une page d'un autre rôle a changé la casquette (ici, ou une séance d'une autre équipe) : on le dit (D-101).
  const was = shownHat, chosen = takeHatChosen();
  shownHat = c.hat;
  const surprise = !!was && !!c.hat && was !== c.hat && !chosen;
  const consoleMode = inConsole(c);
  // Console : la marque Arceau, pas celle d'un club. Sinon : annule un essai de couleurs non enregistré.
  applyBrand(consoleMode ? null : c.club, false);
  // D-149, D-154 : le skin dans les casquettes de qui le porte (Joueuse, Parent, Bénévole), jamais en coach, bureau ou console.
  showSkin(c.club?.id ?? null, !consoleMode && skinHatOn(c));
  const frame = shownSkin() ? `sk-fr sk-fr-${shownSkin()}` : '';
  const route = location.hash.replace(/^#\/?/, '').split('/');
  const email = (await supabase?.auth.getSession())?.data.session?.user.email ?? '';
  const initial = (firstName(c) || (email.endsWith('.arceau.app') ? '' : email)).charAt(0).toUpperCase() || '·';

  // Onglets du rôle principal, d'après les maquettes (D-024, D-036). Le reste : menu du compte.
  const T = {
    home: { id: 'home', href: '#/', icon: 'ti-home', label: 'Accueil' },
    planning: { id: 'planning', href: '#/planning', icon: 'ti-cal', label: 'Planning' },
    team: { id: 'team', href: `#/t/${workTeams(c)[0]?.id ?? ''}`, icon: 'ti-club', label: 'Équipe' },
    plays: { id: 'basket', href: '#/basket', icon: 'ti-plays', label: 'Plays' },
    basket: { id: 'basket', href: '#/basket', icon: 'ti-ball', label: 'Basket' },
    matchs: { id: 'matchs', href: '#/matchs', icon: 'ti-flag', label: 'Matchs' },
    licences: { id: 'licences', href: '#/licences', icon: 'ti-id', label: 'Licences' },
    agenda: { id: 'agenda', href: '#/agenda', icon: 'ti-ticket', label: 'Agenda' },
    // Une icône par module (D-132) : le cœur du bénévolat, pour le bureau comme pour les autres.
    benevolat: { id: 'benevoles', href: '#/benevoles', icon: 'ti-heart', label: 'Bénévolat' },
    equipes: { id: 'equipes', href: '#/club/equipes', icon: 'ti-club', label: 'Équipes' },
    enfants: { id: 'enfants', href: '#/enfants', icon: 'ti-kids', label: 'Enfants' },
    club: { id: 'club', href: '#/club', icon: 'ti-shield', label: 'Club' },
    moi: { id: 'moi', href: '#/moi', icon: 'ti-user', label: 'Moi' },
    visibilite: { id: 'visibilite', href: '#/visibilite', icon: 'ti-eye', label: 'Visibilité' },
    publier: { id: 'publier', href: '#/publier', icon: 'ti-pen', label: 'Publier' },
    // L'abonné (D-110) : les matchs du club, ses suivis, Moi.
    matchsAbonne: { id: 'home', href: '#/', icon: 'ti-flag', label: 'Matchs' },
    suivis: { id: 'suivis', href: '#/suivis', icon: 'ti-star', label: 'Suivis' },
  } as const;
  const persona = personaOf(c);
  // Responsable technique (D-093) : sa casquette a ses onglets.
  const rtView = !consoleMode && isRtView(c);
  const R = {
    equipes: { id: 'rt-equipes', href: '#/rt/equipes', icon: 'ti-club', label: 'Équipes' },
    projet: { id: 'rt-projet', href: '#/rt/projet', icon: 'ti-target', label: 'Projet' },
    joueurs: { id: 'rt-joueurs', href: '#/rt/joueurs', icon: 'ti-people', label: 'Joueurs' },
    coachs: { id: 'rt-coachs', href: '#/rt/coachs', icon: 'ti-whistle', label: 'Coachs' },
  } as const;
  const C = {
    clubs: { id: 'console', href: '#/console', icon: 'ti-club', label: 'Clubs' },
    demandes: { id: 'console-demandes', href: '#/console/demandes', icon: 'ti-hand', label: 'Inscriptions' },
    prospection: { id: 'console-prospection', href: '#/console/prospection', icon: 'ti-megaphone', label: 'Prospection' },   // D-086
  } as const;
  // D-122 : les onglets d'un module éteint disparaissent ; le bureau sans module a Planning · Matchs · Équipes.
  const vol = modOn(c, 'benevolat');
  const BT = { planning: T.planning, matchs: T.matchs, equipes: T.equipes, licences: T.licences, agenda: T.agenda, benevoles: T.benevolat } as const;
  const plays = persona === 'joueur' && !consoleMode && !rtView ? await playsTab(c) : true;
  const tabs = consoleMode ? [C.clubs, C.demandes, C.prospection, T.moi]
    : rtView ? [T.home, R.equipes, R.projet, R.joueurs, R.coachs]
    : persona === 'coach' ? [T.home, T.planning, T.team, T.basket, T.club]
    : persona === 'bureau' ? [T.home, ...bureauTabs(k => modOn(c, k)).map(k => BT[k]), T.club]
    : persona === 'joueur' ? [T.home, T.planning, ...(mvOpen(c) ? [T.basket] : plays ? [T.plays] : []), T.club, T.moi]   // D-164 : « Basket », avec Mains vives
    : persona === 'parent' ? [T.home, T.planning, T.enfants, T.club]   // le bénévolat est dans la casquette Bénévole (D-097)
    : persona === 'partenaire' ? [T.home, T.visibilite, T.publier, T.club]
    : persona === 'supporter' ? [T.home, T.matchs, ...(vol ? [T.benevolat] : []), T.club, T.moi]
    : persona === 'abonne' ? [T.matchsAbonne, T.suivis, T.moi]
    : [T.home, T.planning, T.club, T.moi];
  // L'onglet de la page elle-même (sans historique : une notification, un lien) ; D-139 : la séance et son plan, sans
  // historique, sont du planning ; la prépa, les avantages et Modules et réglages, du club.
  const routeTab = consoleMode && (route[0] === '' || route[0] === undefined || route[0] === 'console') ? (route[1] === 'demandes' ? 'console-demandes' : route[1] === 'prospection' ? 'console-prospection' : 'console')
    : route[0] === '' || route[0] === undefined || route[0] === 'a-faire' ? 'home'   // « Tout voir » de l'accueil (D-155) : l'accueil
    : route[0] === 'club' && route[1] === 'equipes' && tabs.some(t => t.id === 'equipes') ? 'equipes'
    : route[0] === 'club' && route[1] === 'modules' && (route[2] === 'choisir' || route[2] === 'proposer') ? 'home'   // « Ce que le club utilise » : un premier pas
    : route[0] === 'tournoi' ? (route[1] === 'reglages' ? 'club' : ['direct', 'tables', 'qr', 'pret', 'palmares'].includes(route[2] ?? '') ? 'home' : tabs.some(t => t.id === 'agenda') ? 'agenda' : 'home')   // D-177
    : route[0] === 'rt' ? rtTab(route[1]) : route[0] === 't' ? 'team' : ['basket', 'plays', 'play'].includes(route[0]!) ? 'basket'
    : (route[0] === 'seance' || route[0] === 'e') && tabs.some(t => t.id === 'planning') ? 'planning'
    : route[0] === 'lien' ? (persona === 'partenaire' ? 'home' : 'club')   // garder le lien (D-125) : le club ; l'invitation du partenaire : son accueil
    : ['prospection', 'subventions', 'salles', 'partenaires', 'prepa', 'marrainage', 'defis', 'essais', 'membres', 'annonces', 'feuilles', 'derogations', 'formation', 'nouvelle-saison'].includes(route[0]!)
      || (route[0] === 'avantages' && persona === 'bureau') || (route[0] === 'ressentis' && persona === 'bureau')
      || (route[0] === 'bilan' && (route[1] === 'suivi' || route[1] === 'reglages')) ? 'club'
    : route[0] === 'mains-vives' ? (persona === 'parent' ? 'enfants' : 'basket')   // D-164
    : (route[0] === 'accords' || route[0] === 'dossier') && tabs.some(t => t.id === 'enfants') ? 'enfants'   // D-169
    : route[0] === 'ressentis' || route[0] === 'bilan' ? 'home' : route[0]!;   // ce qui se range dans le club (D-111, D-112, D-123, D-125, D-132, D-141, D-143)
  // D-139 : une page d'onglet (ou un de ses segments) n'a pas de retour ; une autre page garde l'onglet d'où l'on vient.
  const here = `#/${route.filter(Boolean).join('/')}`;
  const subTab = route[0] === 'benevoles' && ['equipe', 'badges', 'points'].includes(route[1] ?? '') && !route[2];
  const tabRoot = here === '#/' || subTab || tabs.some(t => t.href === here) || (route[0] === 'rt' && rtIsTabPage(route.slice(1)))
    || (['basket', 'plays'].includes(route[0]!) && route[1] !== 'jeu' && tabs.some(t => t.id === 'basket'))   // Arceau Game (D-162) : des pages avec leur retour
    || (route[0] === 'matchs' && tabs.some(t => t.href === '#/matchs'));
  // Les pages de la barre du haut (cloche, menu du compte) n'allument aucun onglet, ni celles qu'on ouvre depuis elles.
  const topbarPage = !tabs.some(t => t.id === route[0]) && ['notifs', 'aide', 'support', 'moi'].includes(route[0]!);
  const tab: string | null = topbarPage ? null : tabRoot || !from ? routeTab
    : from.tab === null ? null : tabs.some(t => t.id === from.tab) ? from.tab : routeTab;

  mount(root, html`
    <div class="app">
      <header class="topbar">
        <a class="topbar-brand" href="#/">
          ${clubMark(consoleMode ? null : c.club)}
          <span class="tb-text"><span class="tb-name">${consoleMode ? 'Arceau' : c.club?.name ?? 'Arceau'}</span>${roleLine(c) ? html`<span class="tb-role">${roleLine(c)}</span>` : ''}</span>
        </a>
        <div class="topbar-actions">
          ${!consoleMode && persona !== 'partenaire' && c.coachOf.size ? html`<button type="button" class="bell tb-terrain" id="b-terrain" aria-label="Sur le terrain : chrono et drills" data-guide="tb-terrain"><span class="ti ti-chrono" aria-hidden="true"></span></button>` : ''}
          <a class="bell ${route[0] === 'notifs' ? 'on' : ''}" href="#/notifs" aria-label="Notifications"><span class="ti ti-bell" aria-hidden="true"></span><span class="bell-n" hidden></span></a>
          <button type="button" class="avatar ${frame}" id="b-menu" aria-haspopup="true" aria-label="Mon compte">${initial}</button>
        </div>
        <div class="menu" id="menu" hidden>
          ${email && !email.endsWith('.arceau.app') ? html`<p class="menu-who">${email}</p>` : ''}
          <a href="#/moi">Moi</a>
          ${persona === 'abonne' ? '' : html`<a href="#/club">Le club</a>`}
          <a href="#/notifs">Notifications</a>
          <a href="#/aide">Aide et support</a>
          ${c.clubs.length > 1 ? c.clubs.filter(x => x.id !== c.club?.id).map(x => html`<button type="button" data-club="${x.id}">Passer à ${x.name}</button>`) : ''}
          <button type="button" id="b-out">Se déconnecter</button>
        </div>
      </header>
      ${c.hats.length > 1 ? html`<nav class="hat-bar" aria-label="Mes casquettes">${c.hats.map(h => html`
        <button type="button" class="hat ${h.key === c.hat ? 'on' : ''}" data-hat="${h.key}" aria-pressed="${String(h.key === c.hat)}" ${h.key === 'benevole' ? html`data-guide="hat-benevole"` : ''}><span aria-hidden="true">${h.icon}</span>${h.label}${h.key === 'benevole' ? html`<span class="hat-n" hidden></span>` : ''}</button>`)}</nav>` : ''}
      <main id="view" class="view"></main>
      ${tabs.length > 1 ? html`
        <nav class="tabbar" aria-label="Navigation" style="--n:${tabs.length}">
          ${tabs.map(t => html`<a href="${t.href}" class="${tab === t.id ? 'on' : ''}" ${tab === t.id ? 'aria-current="page"' : ''}><span class="ti ${t.icon}" aria-hidden="true"></span>${t.label}</a>`)}
        </nav>` : ''}
    </div>`);

  // Changer de casquette : l'accueil de ce rôle, ses onglets.
  root.querySelectorAll<HTMLButtonElement>('[data-hat]').forEach(b => b.addEventListener('click', () => goHat(root, c, b.dataset.hat as HatKey)));
  // Sur le terrain (D-098) : le chrono et les drills, en un geste, pour le staff.
  $(root, '#b-terrain')?.addEventListener('click', () => void openTerrain(c));
  const menu = $(root, '#menu')!;
  $(root, '#b-menu')!.addEventListener('click', () => { menu.hidden = !menu.hidden; });
  $(root, '#b-out')!.addEventListener('click', async () => { await signOut(); });
  root.querySelectorAll<HTMLButtonElement>('[data-club]').forEach(b => b.addEventListener('click', () => {
    c.club = c.clubs.find(x => x.id === b.dataset.club) ?? c.club;
    refreshHats(c);   // les casquettes de cet autre club (son bénévolat, D-122)
    applyBrand(c.club);
    location.hash = '#/';
    if (appHeadChanged()) { location.reload(); return; }   // l'app de l'autre club sur l'écran d'accueil (D-104)
    void renderApp(root);
  }));

  void refreshBell(root);
  void refreshHatBadge(root, c);
  // Pas pendant une visite guidée : elle change de casquette elle-même et le dit dans sa bulle.
  if (surprise && !document.querySelector('.gd-layer')) hatNotice(root, c);
  const view = $(root, '#view')!;
  // Une page d'un module éteint (vieux lien, notification d'avant) : un écran propre, jamais une erreur (D-122).
  const offModule = !consoleMode && persona !== 'partenaire' && persona !== 'abonne' ? moduleOfRoute(route) : null;
  try {
    // Une bêta fermée à ce club (D-141) : la page n'existe pas pour lui.
    if (offModule && !modOn(c, offModule) && !betaOpen(c, offModule)) mount(view, html`<section class="screen"><div class="empty"><p class="empty-title">Cette page n’existe pas.</p><span class="btn-row"><a class="btn btn-ghost" href="#/">Retour à l’accueil</a></span></div></section>`);
    else if (offModule && !modOn(c, offModule)) renderModuleOff(view, c, offModule, () => void renderApp(root));
    else if (consoleMode && (route[0] === '' || route[0] === undefined || route[0] === 'console')) {
      await renderConsole(view, c, route.slice(1), () => { resetApp(); void renderApp(root); });
    } else if (persona === 'partenaire' && !modOn(c, 'partenaires') && route[0] !== 'moi' && route[0] !== 'aide' && route[0] !== 'notifs') {
      // Le club a éteint ses partenaires (D-122) : l'espace attend, rien n'est supprimé.
      renderPartnerPaused(view, c);
    } else if (persona === 'partenaire') {
      // Compte partenaire (D-037) : son app, rien de la vie interne du club.
      if (route[0] === 'visibilite') await renderPartnerVisibility(view, c);
      else if (route[0] === 'publier') await renderPartnerPublish(view, c);
      else if (route[0] === 'club') await renderPartnerClub(view, c);
      else if (route[0] === 'lien') await renderPartnerLien(view, c);   // le club vous invite, votre bon (D-125)
      else if (route[0] === 'moi') await renderMe(view, c, () => void renderApp(root), route[1]);
      else if (route[0] === 'notifs') await renderNotifs(view, () => void refreshBell(root), c);
      else if (route[0] === 'pistes') await renderMyLeads(view, c);   // apporteur de partenaires (D-096)
      else if (route[0] === 'badges') await renderBadges(view, c, route[1]);   // Ambassade (D-100)
      else if (route[0] === 'aide') await renderHelp(view, c, route[1]);
      else if (route[0] === 'support') await renderSupportInbox(view, c, route[1]);
      else await renderPartnerHome(view, c, { page: route[0] === 'a-faire' });
    } else if (persona === 'abonne') {
      // Abonné (D-110) : les matchs du club et ses suivis ; rien de la vie interne (la base le garantit aussi).
      if (route[0] === 'suivis') await renderMyFollows(view, c, true);
      else if (route[0] === 'moi') await renderMe(view, c, () => void renderApp(root), route[1]);
      else if (route[0] === 'notifs') await renderNotifs(view, () => void refreshBell(root), c);
      else if (route[0] === 'aide') await renderHelp(view, c, route[1]);
      else await renderFollowerHome(view, c, route[0] === 'matchs-club' && route[1] === 'resultats' ? 'past' : 'next');
    } else if (route[0] === 'e' && route[1] && route[2]) {
      // « ?confirmer=… » : la réponse donnée depuis la relance d'une incertaine (D-116).
      const [day, q] = route[2].split('?');
      await renderEvent(view, c, route[1], day!, q ? new URLSearchParams(q) : undefined);
      // D-169 : « ?place=<personne> » : la place proposée pour un enfant (la notification, « À faire »), « D'accord » / « Non merci ».
      const place = q ? new URLSearchParams(q).get('place') : null;
      if (place) void import('./accords-match').then(m => m.openPlaceOffer(c, route[1]!, place, () => void renderApp(root)));
      // « + Renforts » depuis l'accueil : la fiche s'ouvre sur le choix des renforts.
      if (route[3] === 'renfort') view.querySelector<HTMLButtonElement>('#b-renfort')?.click();
    }
    // Responsable technique (D-093) ; côté coach : saisie rapide, brouillon de composition.
    else if (route[0] === 'rt') await renderRt(view, c, route.slice(1));
    else if (route[0] === 'evaluation' && route[1] && route[2]) await renderCoachEvaluation(view, c, route[1], route[2]);
    else if (route[0] === 'composition' && route[1]) await renderCoachComposition(view, c, route[1]);
    else if (route[0] === 'repartir' && route[1] && route[2]) await renderMatchDay(view, c, route[1], route[2]);
    else if (route[0] === 't' && route[1] && route[2] === 'reglages') await renderTeamSettings(view, c, route[1], route[3]);   // D-148 : la ⚙ de l'équipe
    else if (route[0] === 't' && route[1]) await renderTeam(view, c, route[1], route[2] === 'fiche' ? (route[3] ?? 'first') : undefined);   // …/fiche : la carte d'une joueuse (D-176)
    // Partie coach (D-043) : Basket (plays, exercices, séances types), fiche d'un play, composer la séance.
    else if (route[0] === 'basket') await renderBasket(view, c, (route[1] as BasketSeg) || 'plays', route[2]);
    else if (route[0] === 'plays') await renderBasket(view, c, 'plays', route[1]);
    else if (route[0] === 'play' && route[1]) await renderPlayPage(view, c, route[1]);
    else if (route[0] === 'seance' && route[1] && route[2]) await renderSeance(view, c, route[1], route[2], route[3]);   // …/tirage : le tirage au sort (D-176)
    // Un seul écran Matchs (D-132) : tout le club (« Je viens voir », encourager, D-066), filtre par équipe.
    else if (route[0] === 'matchs') await renderMatchs(view, c, route[1]);
    // Prépa physique (D-073) : vue joueuse ou vue coach selon la casquette.
    else if (route[0] === 'prepa') await renderPrepa(view, c, route[1], route[2]);
    // Marrainage (D-067).
    else if (route[0] === 'marrainage') await (route[1] === 'gestion' ? renderMentoringAdmin(view, c) : renderMentorPage(view, c));
    else if (route[0] === 'stats' && route[1]) await renderLiveStats(view, c, route[1], route[2]);
    // La table de marque d'entraînement (D-176) : tenue sur ce téléphone, rien de public (#/table, #/table/fiba3/full).
    else if (route[0] === 'table') await import('./table-local').then(m => m.renderLocalTable(view, c, route[1], route[2]));
    else if (route[0] === 'defis') await renderGroupLife(view, c, route[1], route[2] === 'gages' ? 'gages' : 'defis');
    // Avantages (D-044) : les membres les utilisent, le bureau les gère.
    else if (route[0] === 'avantages') await (route[1] === 'reglages' ? renderPerksAdmin(view, c, route[2]) : renderPerks(view, c));
    // Ressentis, bilan de saison, assistant « Nouvelle saison » (D-143) : dans le socle.
    else if (route[0] === 'ressentis') await renderFeelings(view, c, route.slice(1));
    else if (route[0] === 'bilan') await renderBilan(view, c, route.slice(1));
    else if (route[0] === 'nouvelle-saison') await renderNewSeason(view, c, route[1]);
    else if (route[0] === 'planning') await renderPlanning(view, c);
    else if (route[0] === 'indispos') await renderUnavailability(view, c);
    else if (route[0] === 'club') await renderClubHub(view, c, route[1], () => void renderApp(root), route[2], route[3]);
    else if (route[0] === 'notifs') await renderNotifs(view, () => void refreshBell(root), c);
    else if (route[0] === 'annonces') { await renderAnnouncements(view, c, route[1], route[2] === 'suivi'); void refreshBell(root); }
    // Bureau : demander et suivre (D-038) ; membres, et « vue des membres » du bureau : s'inscrire.
    // Groupes de bénévoles (D-105) : les membres, le fil d'un groupe ; le challenge des groupes.
    // Les réglages du bénévolat (D-127), une seule page en rubriques repliables (D-139).
    else if (route[0] === 'benevoles' && route[1] === 'reglages') await renderVolunteerSettings(view, c, route[2]);
    else if (route[0] === 'benevoles' && route[1] === 'groupe' && route[2] && route[3] === 'membres') await renderGroupMembers(view, c, route[2]);
    else if (route[0] === 'benevoles' && route[1] === 'groupe' && route[2] && route[3] === 'fil') await renderGroupFeed(view, c, route[2]);
    else if (route[0] === 'benevoles' && route[1] === 'challenge') await renderGroupChallenge(view, c);
    else if (route[0] === 'benevoles' && route[1] === 'groupe' && route[2]) await renderVolunteerGroup(view, c, route[2]);
    else if (route[0] === 'benevoles' && route[1] === 'groupes') await renderVolunteerGroups(view, c);
    else if (route[0] === 'benevoles' && route[1] === 'recrues') await renderVolunteerRecruits(view, c);
    else if (route[0] === 'benevoles') await (route[1] === 'profil' ? renderBadges(view, c)
      : route[1] === 'inscription' ? renderVolunteerPage(view, c)
      : route[1] === 'recus' ? renderReceiptsWithKm(view, c)   // reçus fiscaux des bénévoles (D-124), les km des conducteurs (D-132)
      : renderVolunteerBoard(view, c, route[1] === 'equipe' ? 'equipe' : route[1] === 'badges' || route[1] === 'points' ? 'badges' : 'creneaux'));
    // Mes badges, un parcours (D-100) ; l'écusson de la formation à côté du grade (D-141).
    else if (route[0] === 'badges') { await renderBadges(view, c, route[1]); void decorateBadges(view, c, route[1]); }
    // La formation des officiels (D-141, bêta).
    else if (route[0] === 'formation') await renderFormation(view, c, route.slice(1));
    else if (route[0] === 'mains-vives') await renderMainsVives(view, c, route.slice(1));   // D-164 : le premier jeu caméra (bêta)
    else if (route[0] === 'licences' && route[1] === 'import') await renderImport(view, c);
    else if (route[0] === 'licences' && route[1] === 'signatures') await (await import('./accords-club')).renderSignatures(view, c, route[2]);   // D-169
    else if (route[0] === 'licences' && route[1] === 'redaction' && route[2]) await (await import('./documents')).renderDocEditor(view, c, route[2]);   // D-172 : l'éditeur
    else if (route[0] === 'licences' && route[1] === 'reglages') await renderLicenceSettings(view, c, route[2]);   // D-139 : une page à part
    else if (route[0] === 'licences') await renderLicences(view, c);
    else if (route[0] === 'feuilles') await renderFeuilles(view, c);
    else if (route[0] === 'derogations') await renderDerogations(view, c, route[1], route[2]);
    else if (route[0] === 'essais') await renderTrials(view, c);
    // Invitations et rôles (D-075).
    else if (route[0] === 'membres') await renderMembers(view, c);
    else if (route[0] === 'inviter' && route[1] === 'equipe' && route[2]) await renderTeamInvites(view, c, route[2]);
    else if (route[0] === 'inviter') await renderInviteMe(view, c);
    // Les réglages des partenaires, sortis de la page du quotidien (D-132).
    else if (route[0] === 'partenaires' && route[1] === 'reglages') await renderPartnerSettings(view, c, route[2]);
    else if (route[0] === 'partenaires') await renderPartners(view, c, route[1]);
    // Garder le lien avec les partenaires (D-125) : le bureau.
    else if (route[0] === 'lien') await renderLien(view, c, route[1]);
    // Apporteurs de partenaires (D-096) : mes pistes, les ambassadeurs de la saison.
    else if (route[0] === 'pistes') await renderMyLeads(view, c);
    // Dossiers de subvention (D-112) : le bureau seul.
    else if (route[0] === 'subventions') await renderSubventions(view, c, route.slice(1));
    // Prospection de partenaires (D-111) : le club contacte, Arceau prépare (bureau).
    else if (route[0] === 'prospection') await renderProspection(view, c, route.slice(1));
    // Le planning des salles (D-123, module de D-122).
    else if (route[0] === 'salles' && sallesOn(c)) await renderSallesRoute(view, c, route.slice(1));
    else if (route[0] === 'agenda') await renderClubAgenda(view, c);
    // D-175, D-177 : le tournoi du club (organisateurs) ; ses réglages (le bureau).
    else if (route[0] === 'tournoi') await import('./tournoi').then(m => m.renderTournoi(view, c, route));
    else if (route[0] === 'moi') await renderMe(view, c, () => void renderApp(root), route[1]);
    else if (route[0] === 'suivis') await renderMyFollows(view, c);
    else if (route[0] === 'enfants') await renderKids(view, c);
    // D-169 : les accords d'un enfant (ou les miens), le dossier de licence en quatre étapes, les photos à revoir.
    else if (route[0] === 'accords' && route[1]) await (await import('./accords')).renderAccordsPage(view, c, route[1]);
    else if (route[0] === 'dossier' && route[1]) await (await import('./accords')).renderDossier(view, c, route[1], route[2]);
    else if (route[0] === 'photos-a-revoir' && route[1]) await (await import('./accords-club')).renderPhotoReview(view, c, route[1]);
    // Aide et support (D-082) ; boîte du support pour l'équipe Arceau.
    else if (route[0] === 'aide') await renderHelp(view, c, route[1]);
    else if (route[0] === 'support') await renderSupportInbox(view, c, route[1]);
    // L'accueil ; « Tout voir » de son À faire (D-155) : la page À faire, les mêmes lignes.
    else await (rtView ? renderRtHome(view, c, { page: route[0] === 'a-faire' }) : renderHome(view, c, { page: route[0] === 'a-faire' }));
  } catch {
    mount(view, html`<div class="empty"><p class="empty-title">Chargement impossible.</p><p>Vérifie ta connexion puis réessaie.</p></div>`);
  }
  // Toute page qui n'est pas un onglet a son retour (D-074) ; D-139 : « ‹ X » dit d'où l'on vient et y ramène, la ⚙ du
  // module à gauche du « ? » (src/ui/nav.ts).
  const tabLabel = tabRoot ? (tabs.find(t => t.id === routeTab)?.label ?? null) : null;
  finishNav(view, { ctx: c, route, tabRoot, tabLabel: tabLabel === 'Club' ? 'Le club' : tabLabel, tab, from });
  window.scrollTo(0, 0);
  // Guide interactif (D-091) : visite en cours, « ? » de l'écran, démo guidée.
  guideAfterRender(view, c, location.hash, email, () => void renderApp(root));
}

// « Bénévole › » sur l'accueil d'un rôle (D-097) : la casquette Bénévole, son accueil.
document.addEventListener('click', e => {
  const a = (e.target as HTMLElement).closest<HTMLElement>('[data-go-hat]');
  if (!a || !ctx || !appRoot || a.closest('.gd-layer')) return;
  e.preventDefault();
  goHat(appRoot, ctx, a.dataset.goHat as HatKey);
});
// Un créneau pris ou rendu : la pastille suit.
window.addEventListener('arceau:creneaux', () => { if (ctx && appRoot) void refreshHatBadge(appRoot, ctx); });

/** Changement de casquette sans surprise (D-101) : une page d'un autre rôle (un créneau de bénévole ouvert
 *  depuis l'accueil de la joueuse, une séance d'une autre équipe…) change la casquette ; un petit bandeau
 *  sous la barre des casquettes le dit, le temps de le lire. */
function hatNotice(root: HTMLElement, c: Ctx): void {
  const hat = c.hats.find(h => h.key === c.hat);
  const bar = root.querySelector<HTMLElement>('.hat-bar');
  if (!hat || !bar) return;
  document.querySelector('.hat-notice')?.remove();
  const n = document.createElement('div');
  n.className = 'hat-notice';
  n.setAttribute('role', 'status');
  n.innerHTML = `<span aria-hidden="true">${hat.icon}</span>`;
  n.append(`Côté ${hat.label}`);
  n.style.top = `${Math.max(0, bar.getBoundingClientRect().bottom) + 8}px`;
  document.body.append(n);
  bar.querySelector('.hat.on')?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  setTimeout(() => n.classList.add('out'), 2600);
  setTimeout(() => n.remove(), 3000);
}

/** Pastille de la casquette Bénévole (D-097) : les places qui manquent dans les 7 jours, que je peux prendre (ni à moi,
 *  ni réservées à un autre groupe, ni en conflit avec ce qui m'occupe) — le même chiffre que la ligne de l'accueil (D-103). */
async function refreshHatBadge(root: HTMLElement, c: Ctx): Promise<void> {
  const badge = root.querySelector<HTMLElement>('.hat-n');
  if (!badge) return;
  const n = await weekPlaces(c);
  badge.hidden = n === 0;
  badge.textContent = n > 9 ? '9+' : String(n);
  badge.closest('.hat')?.setAttribute('aria-label', `Bénévole${n ? ` : ${n} ${n > 1 ? 'places' : 'place'} à prendre cette semaine` : ''}`);
}

/** Pastille de la cloche : nombre de notifications non lues. */
export async function refreshBell(root: HTMLElement): Promise<void> {
  const badge = root.querySelector<HTMLElement>('.bell-n');
  if (!badge) return;
  const n = await unreadCount().catch(() => 0);
  badge.hidden = n === 0;
  badge.textContent = n > 9 ? '9+' : String(n);
}
